import { getModel } from '@smx-ui-model/store-model';
import { GenericModelSchemaType, StoreModelType, TableResourceType } from '@smx-ui-model/types';
import { Flex, Form } from 'antd';
import type { FormInstance } from 'antd/es/form/hooks/useForm';
import * as React from 'react';
import { memo, useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';

import FormButtonDelete from './form-button-delete';
import FormButtonSave from './form-button-save';
import { SmxInspectorContext } from './inspector-provider';
import { InspectorReduxState } from './store/inspector-redux-state';

interface FormProcessorProps {
    modelName: keyof StoreModelType;
    entity?: TableResourceType;
    form?: FormInstance;
}

const FormProcessor: React.FC<FormProcessorProps> = ({ modelName, form, entity }) => {
    const values = Form.useWatch([], { form, preserve: true });
    const { connectionId } = useContext(SmxInspectorContext);
    const storeConnectionId = useSelector<InspectorReduxState, { [key in keyof StoreModelType]: string } | undefined>(
        (state) => state.model.storeConnectionId,
    );

    const model = getModel<GenericModelSchemaType>(modelName);

    useEffect(() => {
        console.log('updates values >>>', values, model);
    }, [values]);

    const getDataToSave = () => {
        if (!values) {
            return null;
        }

        const newData: { [key: string]: any } = {};

        model.context?.inspectorInput?.forEach((fieldName) => {
            newData[fieldName] = values[fieldName];
        });

        return newData;
    };

    const data = getDataToSave();

    const getPrefix = (prefix?: string) => {
        switch (prefix) {
            case 'projectId':
                return values?.projectId || '';
            default:
                return '';
        }
    };

    const currentConnectionId = storeConnectionId?.[model.name + getPrefix(model.prefixConnection)] || connectionId;

    return (
        <Flex flex={1} gap={5} justify={'center'}>
            {model.action?.inspector?.map((action, index) => (
                <Flex key={index}>{action({ entity, values, form, connectionId: currentConnectionId })}</Flex>
            ))}
            {
                // Todo not all mutation has connectionId (ApplicationVersion)
            }
            {((model.mutation?.create && data && !entity) || (model.mutation?.update && data && !!entity)) && (
                <FormButtonSave model={model} data={data} connectionId={currentConnectionId} form={form} />
            )}
            {model.mutation?.delete && currentConnectionId && (
                <FormButtonDelete model={model} connectionId={currentConnectionId} />
            )}
        </Flex>
    );
};

export default memo(FormProcessor);
